import { defineComponent as t, createElementBlock as a, openBlock as i, createVNode as l, createElementVNode as s, unref as o, toDisplayString as c, renderSlot as d } from "vue";
import { ScalarIconButton as m } from "@scalar/components";
import { useSidebar as u } from "../features/sidebar/hooks/useSidebar.js";
const p = { class: "references-mobile-header t-doc__header" }, b = { class: "references-mobile-breadcrumbs" }, _ = { class: "references-mobile-header-actions" }, M = /* @__PURE__ */ t({
  __name: "MobileHeader",
  props: {
    breadcrumb: {}
  },
  setup(f) {
    const { isSidebarOpen: e } = u();
    return (r, n) => (i(), a("div", p, [
      l(o(m), {
        icon: o(e) ? "Close" : "Menu",
        label: o(e) ? "Close Menu" : "Open Menu",
        size: "md",
        onClick: n[0] || (n[0] = (h) => e.value = !o(e))
      }, null, 8, ["icon", "label"]),
      s("span", b, c(r.breadcrumb), 1),
      s("div", _, [
        d(r.$slots, "actions", {}, void 0, !0)
      ])
    ]));
  }
});
export {
  M as default
};
